import Confirm from "../Generic/ConfirmDialog";
import { iUser } from "../../interfaces/iUser";
import { iActionProps, iEnquiry } from "../../interfaces/iEnquiry";

import {
    NoActionRequiredEnquiryRequest,
    NoActionRequiredEnquiries as NoActionRequiredEnquiriesCall,
} from "../../Logic/EmsAPI/Enquiries";
import { logErrorToService } from "../../error-boundary/logerror";

interface Props extends iActionProps {
    enquiries: Array<iEnquiry>;
    UserList?: iUser[] | undefined;
}

function NoActionRequiredEnquiries(props: Props) {
    async function UpdateEnquiryStatus1() {
        window.alert("Update");
    }
    async function UpdateEnquiryStatus() {
        let request: NoActionRequiredEnquiryRequest = {
            Enquiries: props.enquiries.map(enq => enq.id),
        };
        let response = await NoActionRequiredEnquiriesCall(request);
        if (!response.isOk) {
            props.onError("Unable to perform NoActionRequired on enquiry.", response.errorLogID);
            return;
        }
        props.onCreated();
    }

    return (
        <>
            <Confirm
                title="Warning"
                onCancel={() => props.onCancel()}
                onConfirm={() => {
                    UpdateEnquiryStatus();
                }}
            >
                <>
                    This action will return the enquiry to its previous state.
                    <br />
                    Are you sure you want to continue?
                </>
            </Confirm>{" "}
            <></>
        </>
    );
}
export default NoActionRequiredEnquiries;
